import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
	Loader,
	BaasicConfirmModal,
	TableFilter,
	BaasicTable,
	BaasicCheckbox,
	BaasicHeader,
	BaasicTableExport,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { fileNames } from 'common/constants';

const ProductListTemplate = ({
	viewStore,
	viewStore: {
		loading,
		listStore,
		tableData,
		baasicTableSettingsViewStore,
		queryUtility,
		columnFilterSetup,
		removeFiltersModal: { removeFiltersConfirm },
		onCheck,
		showOnlyActiveSkus,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader
				title="MAINMENU.ADMINISTRATION.PRODUCTS"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
			>
				<div className="flex--primary">
					<div>
						<BaasicCheckbox
							id={'showInactiveSkus'}
							onChangeCallback={onCheck}
							label="PRODUCTVIEW.SHOWINACTIVESKUS"
							checked={showOnlyActiveSkus}
							className="input--check input--check--negative"
						/>
					</div>
					<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.product} />
				</div>
			</BaasicHeader>
			<BaasicTable
				{...{
					tableData,
					queryUtility,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(ProductListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/ProductListTemplate.jsx